export default __webpack_public_path__ + "assets/objectType/md_galamerkisROUTE.png";